export default __webpack_public_path__ + "images/racion-stone-1.svg";